import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emojiFlag',
  standalone: true,
})
export class EmojiFlagPipe implements PipeTransform {
  transform(value: string) {
    return value.toUpperCase().replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
  }
}
